import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '../../components';

const TextAreaInput = (props) => {
  const { id, label, value, onChange, disabled, resize } = props;
  return (
    <div className="input">
      <Label attr={id} text={label} />
      <textarea
        id={id}
        type="text"
        value={value}
        onChange={onChange}
        disabled={disabled}
        resize={resize}
      />
    </div>
  );
};

export default TextAreaInput;

TextAreaInput.propTyptes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  resize: PropTypes.string,
};

TextAreaInput.defaultProps = {
  disabled: false,
  resize: 'vertical',
};
